import { render, staticRenderFns } from "./profile_address.vue?vue&type=template&id=c1327618&"
import script from "./profile_address.vue?vue&type=script&lang=js&"
export * from "./profile_address.vue?vue&type=script&lang=js&"
import style0 from "./profile_address.vue?vue&type=style&index=0&id=c1327618&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports